import { render, staticRenderFns } from "./GlobalSearchSingleResultFooter.vue?vue&type=template&id=6be1f8da&"
import script from "./GlobalSearchSingleResultFooter.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchSingleResultFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports